import styled from 'styled-components';

export const StyledOrderPage = styled('div')`
  @media only screen and (max-width: 1200px) {
    .container {
      padding: 0;
    }
  }
`;
